var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCourseModule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.492,
    height: 43.467,
    viewBox: "0 0 44.492 43.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-layers",
    "data-name": "Icon feather-layers",
    transform: "translate(-0.988 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5995",
    "data-name": "Path 5995",
    d: "M23.234,3,3,13.117,23.234,23.234,43.467,13.117Z",
    fill: "none",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5996",
    "data-name": "Path 5996",
    d: "M3,25.5,23.234,35.617,43.467,25.5",
    transform: "translate(0 7.85)",
    fill: "none",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5997",
    "data-name": "Path 5997",
    d: "M3,18,23.234,28.117,43.467,18",
    transform: "translate(0 5.234)",
    fill: "none",
    stroke: "#525252",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseModule);
export default __webpack_public_path__ + "static/media/icon_course_module.2a0e6263836a29780ca637ed7bbfe05e.svg";
export { ForwardRef as ReactComponent };